import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { ComponentsModule } from '@components/components.module';
import { CoreModule } from '@core/core.module';
import {
	DOCUMENT_REQUEST_STATUS,
	DocumentRequest,
} from '@models/document-requests';
import { UntilDestroy } from '@ngneat/until-destroy';
import { select, Store } from '@ngxs/store';
import { DocumentRequestsSelectors } from '@state/document-requests/document-requests.selectors';
import * as DocumentRequestsActions from 'src/app/shared/state/document-requests/document-requests.actions';
import { DrawerService } from 'src/app/ui/drawer/drawer.service';
import { ContentHeaderComponent } from '../../../../ui/content-header/content-header.component';
import { UiModule } from '../../../../ui/ui.module';
import { NavbarModule } from '../../../app-main/navbar/navbar.module';
import { RequestDetailsComponent } from './request-details/request-details.component';
import { RequestFormComponent } from './request-form/request-form.component';
import { UserSelectors } from '@state/global/user';

@UntilDestroy()
@Component({
	selector: 'app-requests',
	templateUrl: './requests.component.html',
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatSelectModule,
		MatButtonModule,
		MatTableModule,
		MatIconModule,
		ComponentsModule,
		NavbarModule,
		UiModule,
		ContentHeaderComponent,
		CoreModule,
	] as const,
	standalone: true,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RequestsComponent {
	store = inject(Store);
	canMakeRequests = select(UserSelectors.canUserMakeRequests);
	documentRequests$ = this.store.select(
		DocumentRequestsSelectors.getDocumentRequests,
	);
	displayedColumns: string[] = ['name', 'type', 'size', 'action'];
	DocumentRequestStatus = DOCUMENT_REQUEST_STATUS;

	constructor(private drawerService: DrawerService) {}

	openRequestDetails(request: DocumentRequest) {
		this.drawerService.openDrawer(RequestDetailsComponent, {
			title: 'Document Request Details',
			data: {
				requestId: request.id,
			},
		});
	}

	async cancelRequest(request: DocumentRequest) {
		await this.store.dispatch(
			new DocumentRequestsActions.Update({
				...request,
				status: DOCUMENT_REQUEST_STATUS.CANCELED,
			}),
		);
	}

	closeDrawer() {
		this.drawerService.closeDrawer();
	}

	openRequestFormDrawer() {
		this.drawerService.openDrawer(RequestFormComponent, {
			title: 'New Document Request',
			data: {
				closeDrawer: this.closeDrawer.bind(this),
			},
			noStyle: true,
		});
	}
}
